var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadMotorway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51076 2.53467L4.93813 4.20243L5.69477 4.46223L6.2674 2.79446L5.51076 2.53467Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24976 6.20291L1.84558 13.205L2.60222 13.4648L5.0064 6.4627L4.24976 6.20291Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1729 6.46441L11.9294 6.20435L14.3361 13.2056L13.5795 13.4657L11.1729 6.46441Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6657 2.53715L9.90919 2.79721L10.4824 4.46478L11.239 4.20472L10.6657 2.53715Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68669 2.66658H8.48669V4.33325H7.68669V2.66658Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48669 6.33325H7.68669V8.66658H8.48669V6.33325Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68669 10.3333H8.48669V13.3332H7.68669V10.3333Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4867 5.73325H15.42V4.93325H0.753357V5.73325H2.69002L1.86002 7.49658L2.58336 7.83658L3.57336 5.73325H12.6034L13.5934 7.83658L14.3167 7.49658L13.4867 5.73325Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadMotorway);
export default __webpack_public_path__ + "static/media/road-motorway.b8923da8d92bc79ff7e5fb0fe3b8b481.svg";
export { ForwardRef as ReactComponent };